import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import MainLayout from "./main-layout/MainLayout";

const App = ({ store }) => (
  <Provider store={store}>
    <BrowserRouter>
      <Route path="/" >
        <MainLayout/>
      </Route>
    </BrowserRouter>
  </Provider>
);

export default App;
